import React from 'react';
import ReactDOM from 'react-dom';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';

@observer
export class ModalDialogsContainerComponent extends OrbitComponent {
    render() {
        const currentDialogs = this.services.dialog.currentDialogs.map(dialogComponent => ReactDOM.createPortal(dialogComponent, this.services.dom.body));
        if(currentDialogs.length === 0) {
            return null;
        }
        return (<>
            {currentDialogs}
        </>);
    }
}